import { define } from 'wicked-elements'
import { register, deregister } from 'tiny-pulsar'
import innout from '../lib/innout'

define('[data-component~="nav-active"]', {
  init() {
    this.$navLinks = this.element.querySelectorAll('.nav-link')
    this.$sections = [...document.querySelectorAll('[data-section]')]
    this.checkSection = this.checkSection.bind(this)
    this.handleSectionEnter = this.handleSectionEnter.bind(this)

    this.tracker = innout({
      elements: this.$sections,
      offset: () => window.innerHeight / 2,
      onEnter: this.handleSectionEnter
    })
  },
  connected() {
    register('sections', this.checkSection)
  },
  disconnected() {
    deregister('sections')
  },
  checkSection() {
    this.tracker.check()
  },
  handleSectionEnter(section) {
    this.$navLinks.forEach(link => {
      link.classList.toggle('active', link.getAttribute('href') === `#${section.id}`)
    })
  }
}) 